import groups from "./groups";
import chats from "./chats";
import { serialize } from "@/utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/nurse",
  },
  modules: {
    groups,
    chats,
  },
  actions: {
    getStatistics({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/statistics?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
  },
};
